import webActionCreators from './webActions';
import adminActionCreators from './adminActions';
import emptyInvoiceActionCreators from './emptyInvoiceActions';
import invoiceActionCreators from './invoiceActions';
import allowanceActionCreators from './allowanceActions';
import prizedInvoiceActionCreators from './prizedInvoiceActions';
import turnkeyUploadLogActionCreators from './turnkeyUploadLogActions';

export default {
	webActionCreators,
	adminActionCreators,
	emptyInvoiceActionCreators,
	invoiceActionCreators,
	allowanceActionCreators,
	prizedInvoiceActionCreators,
	turnkeyUploadLogActionCreators,
};



// WEBPACK FOOTER //
// ./src/actions/creators/index.js